import type { baiduModelConfig } from './types';
import { googleConfigs } from './configs/google';
import { openaiConfigs } from './configs/openai';

/**
 * 模型配置映射
 */
export const baiduModelConfigs: Record<string, baiduModelConfig> = {
    ...googleConfigs,
    ...openaiConfigs,
};